import React from 'react';
import { TileContainer, StyledLogo, StyledName, StyledType } from 'components/Global/EntityPicker/styled.js';
import Background from '@bit/knotchinc.web-react-components.background';


const EntityTile = ({ onClick, selectedEntities, data }) => {
  const { logo_url, name, type, public_id } = data;
  return (
    <TileContainer
      selected={selectedEntities.find(el => el.public_id === public_id)}
      onClick={() => onClick(data)}
    >
      <StyledLogo>
        <Background url={logo_url} opacity={0} color="white" />
      </StyledLogo>
      <StyledName>{name}</StyledName>
      <StyledType>{type}</StyledType>
    </TileContainer>
  );
};

export default EntityTile;
